<template>
  <b-card>
	<validation-observer ref="addDeviceRules">
	  
	  <b-form @submit.prevent>
	    <b-row>
	      <b-col md="6">
	        <b-form-group :label="$t('Device Id')" class="required-field">
			  <validation-provider
			    #default="{ errors }"
			    :name="$t('Device Id')"
			    rules="required"
			  >
			    <b-form-input :placeholder="$t('Please input')+$t('Device Id')" v-model="data.deviceIdentifier"/>
			    <small class="text-danger">{{ errors[0] }}</small>
			  </validation-provider>  	
	        </b-form-group>
	      </b-col>
	      <b-col md="6">
	        <b-form-group :label="$t('Hardware Info')" class="required-field">
	          <validation-provider
	            #default="{ errors }"
	            :name="$t('Hardware Info')"
	            rules="required"
	          >
			    <v-select
			      v-model="data.devHwPlatformIdentifier"
			      :options="deviceHwPlatforms"
			      :placeholder="$t('Please select')+$t('Hardware Info')"
				  :reduce="devHwPlatformString => devHwPlatformString.devHwPlatformIdentifier"
				  label="devHwPlatformString"
			    />
	            <small class="text-danger">{{ errors[0] }}</small>
	          </validation-provider> 
	        </b-form-group>
	      </b-col>
	      <!--<b-col md="6">
	        <b-form-group :label="$t('Software Version')">
	          <validation-provider
	            #default="{ errors }"
	            :name="$t('Software Version')"
	            rules="required"
	          >
	            <b-form-select v-model="data.devSwVersionIdentiifer" :options="deviceSwVersions"/>
	            <small class="text-danger">{{ errors[0] }}</small>
	          </validation-provider>
	        </b-form-group>
	      </b-col>-->
	      <!--<b-col md="6">
	        <b-form-group :label="$t('Operating System')">
		      <validation-provider
		        #default="{ errors }"
		        :name="$t('Operating System')"
		        rules="required"
		      >
		        <b-form-select v-model="data.devOsTypeIdentifier" :options="deviceOsTypes"/>
		        <small class="text-danger">{{ errors[0] }}</small>
		      </validation-provider>		
	        </b-form-group>
	      </b-col>
	      <b-col md="6">
	        <b-form-group :label="$t('Device Status')">
			  <validation-provider
			    #default="{ errors }"
			    :name="$t('Device Status')"
			    rules="required"
			  >
			    <b-form-select v-model="data.dicDevStatusIdentifier" :options="deviceStatus"/>
			    <small class="text-danger">{{ errors[0] }}</small>
			  </validation-provider>		
	        </b-form-group>
	      </b-col>-->
		  <b-col md="6">
		    <b-form-group :label="$t('Owner Users')">
			  <v-select
			      v-model="data.ownerUserList"
			      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
			      multiple
			      :options="userOptions"
				  :placeholder="$t('Please select')+$t('Owner Users')"
			  />
		    </b-form-group>
		  </b-col>
		  <b-col md="6">
		    <b-form-group :label="$t('Owner Groups')">
			  <v-select
			      v-model="data.ownerGroupList"
			      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
			      multiple
			      :options="groupOptions"
				  :placeholder="$t('Please select')+$t('Owner Groups')"
			  />	
		    </b-form-group>
		  </b-col>
	  
	      <b-col md="12">
	        <b-button type="submit" variant="primary" class="mr-1" @click="onSubmit">
	          {{$t("Submit")}}
	        </b-button>
	        <b-button type="reset" variant="outline-secondary" @click="onResetForm">
	          {{$t("Reset")}}
	        </b-button>
	      </b-col>
	    </b-row>
	  </b-form>
	  
	</validation-observer>  
    

  </b-card>
</template>

<script>
import { ValidationProvider, ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'	
import {
  BCard, BRow, BCol, BFormGroup, BFormInput, BFormCheckbox, BForm, BButton,BFormSelect
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import ToastificationContent from '@core/components/toastification/ToastificationContent'
import { 
	//getDeviceSwVersion,
	getDeviceHwPlatform,
	//getDeviceOsType,
	//getDeviceStatus,
	addDevice, 
	getDevice, 
	editDevice,
	getUserOptions,
	getGroupOptions,
	} from '@/api/device'

export default {
  components: {
	ValidationProvider,
	ValidationObserver,  
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormCheckbox,
    BForm,
    BButton,
    BFormSelect,
	required,
	vSelect
  },
  name: 'Detail',
  props: {
  	  isEdit:{
  		type: Boolean,
  		default: false
  	  }
  },
  data() {
    return {
      //设备软件版本列表
      //deviceSwVersions: [{ value: null, text: this.$t('Please select')+this.$t('Software Version') }],
      //设备硬件平台类别列表
      deviceHwPlatforms: [],
      //操作系统类别列表
      //deviceOsTypes: [{ value: null, text: this.$t('Please select')+this.$t('Operating System') }],
      //设备状态列表
      //deviceStatus: [{ value: null, text: this.$t('Please select')+this.$t('Device Status') }],
	  //用户选项
	  userOptions:[],
	  //用户组选项
	  groupOptions:[],
      data:{
        deviceName: null,
        deviceIdentifier: null,
        //dicDevStatusIdentifier: null,
        //devOsTypeIdentifier: null,
        //devSwVersionIdentiifer: null,
        devHwPlatformIdentifier: null,
        ownerUserList: [],
        ownerGroupList: []
      },
    }
  },
  created() {
	localize(this.$i18n.locale)  
    //this.getDeviceSwVersion()
    this.getDeviceHwPlatform()
    //this.getDeviceOsType()
    //this.getDeviceStatus()
	this.getUserOptions()
	this.getGroupOptions()
	if(this.isEdit){
	  this.getDevice(this.$route.params.name)
	}  
  },
  methods: {
    //获取设备软件版本列表
   /* getDeviceSwVersion(){
      getDeviceSwVersion().then(response => {
        response.data.forEach((item)=>{
          this.deviceSwVersions.push({ text:item.devSwVersionString, value:item.devSwVersionIdentiifer})
        })
      })
    },*/
    //获取设备硬件平台类别列表
    getDeviceHwPlatform(){
      getDeviceHwPlatform().then(response => {
		this.deviceHwPlatforms = response.data 
      })
    },
    //获取操作系统类别列表
    /*getDeviceOsType(){
      getDeviceOsType().then(response => {
        response.data.forEach((item)=>{
          this.deviceOsTypes.push({ text:item.devOsTypeString, value:item.devOsTypeIdentifier});
        })
      })
    },*/
    //获取设备状态列表列表
    /*getDeviceStatus(){
      getDeviceStatus().then(response => {
        response.data.forEach((item)=>{
          this.deviceStatus.push({ text:item.dicDevStatusString, value:item.dicDevStatusIdentifier})
        })
      })
    },*/
	//用户选项
	getUserOptions(){
      getUserOptions().then(response => {
		this.userOptions = response.data 
      })
    },
	//用户组选项
	getGroupOptions(){
	  getGroupOptions().then(response => {
		this.groupOptions = response.data 
	  })
	},
	//设备详情
	getDevice(name){
	  getDevice(name)
	    .then(response => {
		  let data = response.data
		  this.data = {
		    deviceIdentifier: data.deviceIdentifier,
		    dicDevStatusIdentifier: data.dicDevStatus,
		    //devOsTypeIdentifier: data.osType,
		    //devSwVersionIdentiifer: data.softwareVersion,
		    devHwPlatformIdentifier: data.hardwarePlatform,
		    ownerUserList: data.ownerUserList?data.ownerUserList.split(','):null,
		    ownerGroupList: data.ownerGroupList?data.ownerGroupList.split(','):null	  
		  }
		})
	},
	//提交表单
	onSubmit(){
	  if(this.isEdit){
	    this.editDevice()
	  }	
	  else{
		this.addDevice()
	  }
	},
    //添加设备
    addDevice(){
	  	
	  this.$refs.addDeviceRules.validate().then(success => {
	    if (success) {
	      addDevice(this.data)
	      .then(response => {
	        this.$router.replace({ name: 'diagnostic-device-list' })
	            .then(() => {
	              this.$toast({
	                component: ToastificationContent,
	                position: 'top-right',
	                props: {
	                  title: this.$t('Operation Success'),
	                  icon: 'CoffeeIcon',
	                  variant: 'success',
	                  text: this.$t('Operation Success'),
	                },
	              })
	            })
	      })
	    }
	  })	
		
    },
	//修改设备
	editDevice(){
	
	  this.$refs.addDeviceRules.validate().then(success => {
	    if (success) {
			
	      editDevice(this.data)
	      .then(response => {
	        this.$router.replace({ name: 'diagnostic-device-list' })
	          .then(() => {
	            this.$toast({
	              component: ToastificationContent,
	              position: 'top-right',
	              props: {
	                title: '修改成功',
	                icon: 'CoffeeIcon',
	                variant: 'success',
	                text: '修改设备成功 !',
	              },
	            })
	          })  
	      })
		  
	    }
	  })		
		
	},
	//重置表单
	onResetForm(){
	  this.data = {
        devHwPlatformIdentifier: null,
        ownerUserList: [],
        ownerGroupList: []
      }
	}


  },
}
</script>
<style lang="scss" >
@import '@core/scss/vue/libs/vue-select.scss';
</style>